<template>
  <div class="ai-chat-form-wrapper">
    <form class="ai-chat-form" @submit.prevent="onSubmit">

      <div class="ai-chat-form-group">
        <input v-model="prompt"
               type="text"
               name="ai-chat-prompt"
               id="ai-chat-prompt"
               :placeholder="`Message ${aiLabel}...`"
               :aria-label="`Message ${aiLabel}...`"
               minlength="1"
               required
               autofocus
        >
        <button type="submit" class="btn" id="ai-chat-submit-button" :disabled="loading">
          {{ loading ? 'Loading' : 'Submit' }}
        </button>
      </div>

    </form>
  </div>
</template>

<script lang="ts">
import { defineComponent } from 'vue';

interface DataState {
  prompt: string;
}

export default defineComponent({
  props: {
    aiLabel: {
      type: String,
      required: true,
    },
    loading: {
      type: Boolean,
      default: false,
    },
  },
  data(): DataState {
    return {
      prompt: '',
    };
  },
  methods: {
    onSubmit() {
      this.$emit('prompt', {
        role: 'user',
        content: this.prompt,
      });
      this.prompt = '';
    },
  },
});
</script>

<style lang="less" scoped>
.ai-chat-form-wrapper {
  position: absolute;
  bottom: 0;
  left: 0;
  right: 0;
  width: 100%;

  .ai-chat-form {
    background-color: #eff0f1;
    margin-left: auto;
    margin-right: auto;
    max-width: 800px;
    padding: 1rem;
    border: 1px solid #9e9e9e;
    border-radius: .5rem;

    .ai-chat-form-group {
      display: flex;
      gap: 1rem;
      align-items: center;
    }
  }
}
</style>
